/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Request to assign cross-tenant roles to users
 * @export
 * @interface AssignCrossTenantRolesRequest
 */
export interface AssignCrossTenantRolesRequest {
    /**
     * ID of the tenant relationship
     * @type {string}
     * @memberof AssignCrossTenantRolesRequest
     */
    relationshipId: string;
    /**
     * List of user IDs to assign roles to
     * @type {Array<string>}
     * @memberof AssignCrossTenantRolesRequest
     */
    userIds: Array<string>;
    /**
     * List of role IDs to assign
     * @type {Array<string>}
     * @memberof AssignCrossTenantRolesRequest
     */
    roleIds: Array<string>;
    /**
     * When the role assignments should expire
     * @type {Date}
     * @memberof AssignCrossTenantRolesRequest
     */
    expiresAt?: Date;
    /**
     * Reason for the role assignment
     * @type {string}
     * @memberof AssignCrossTenantRolesRequest
     */
    reason?: string;
}

/**
 * Check if a given object implements the AssignCrossTenantRolesRequest interface.
 */
export function instanceOfAssignCrossTenantRolesRequest(value: object): value is AssignCrossTenantRolesRequest {
    if (!('relationshipId' in value) || value['relationshipId'] === undefined) return false;
    if (!('userIds' in value) || value['userIds'] === undefined) return false;
    if (!('roleIds' in value) || value['roleIds'] === undefined) return false;
    return true;
}

export function AssignCrossTenantRolesRequestFromJSON(json: any): AssignCrossTenantRolesRequest {
    return AssignCrossTenantRolesRequestFromJSONTyped(json, false);
}

export function AssignCrossTenantRolesRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): AssignCrossTenantRolesRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'relationshipId': json['relationshipId'],
        'userIds': json['userIds'],
        'roleIds': json['roleIds'],
        'expiresAt': json['expiresAt'] == null ? undefined : (new Date(json['expiresAt'])),
        'reason': json['reason'] == null ? undefined : json['reason'],
    };
}

export function AssignCrossTenantRolesRequestToJSON(json: any): AssignCrossTenantRolesRequest {
    return AssignCrossTenantRolesRequestToJSONTyped(json, false);
}

export function AssignCrossTenantRolesRequestToJSONTyped(value?: AssignCrossTenantRolesRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'relationshipId': value['relationshipId'],
        'userIds': value['userIds'],
        'roleIds': value['roleIds'],
        'expiresAt': value['expiresAt'] == null ? undefined : ((value['expiresAt']).toISOString()),
        'reason': value['reason'],
    };
}

